import React, {useState,useEffect} from "react";
import { StyleSheet, Text, View, Button, ImageBackground,Image,Dimensions,TouchableOpacity,TextInput, Alert} from "react-native";
import imgSrc2 from './images/clemgram_black.jpg';
import prof1 from './images/prof1.png';
import post from './images/nopost.png';
import editt from './images/edit.png';
import saveprof from './images/saveprofile.png';
import p1 from './images/p1.png';
import p2 from './images/p2.png';
import p3 from './images/p3.png';
import p4 from './images/p4.png';
import p5 from './images/p5.png';
import continu from './images/continue.png';
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set,update } from "firebase/database";
//<ImageBackground source={imgSrc} resizeMode="cover" style={styles.image}>

// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object
const firebaseConfig = {
    // ...
    apiKey: "AIzaSyB3kIHJz7Ey5FXzUVsN5Gfjp8tBaG6xYbw",
      authDomain: "stress-and-privacy.firebaseapp.com",
    databaseURL: "https://stress-and-privacy-default-rtdb.firebaseio.com",
      projectId: "stress-and-privacy",
      storageBucket: "stress-and-privacy.appspot.com",
      messagingSenderId: "738098786959",
      appId: "1:738098786959:web:a6469cc294345688a476fa" 
  };
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  
  
  // Initialize Realtime Database and get a reference to the service
  const database = getDatabase(app);
const Info = (props) => {
	
	const [firstname,setFirstname]=useState(props.navigation.state.params.firstname);
	const [lastname,setLastname]=useState(props.navigation.state.params.lastname);
	const [email,setEmail]=useState(props.navigation.state.params.email);
	const [bio,setBio]=useState(props.navigation.state.params.bio);
	const [ppic,setPpic]=useState(props.navigation.state.params.pic);
	const [page,setPage]=useState(1);
	const [q1,setQ1]=useState('Prefer not to say!');
	const [q2,setQ2]=useState('Prefer not to say!');
	const [q3,setQ3]=useState('Prefer not to say!');
	const [q4,setQ4]=useState('Prefer not to say!');
	const [q5,setQ5]=useState('Prefer not to say!');
	const [pro,setPro]=useState(1);
	const [pp,setPP]=useState(prof1);
	/*
	const [firstname,setFirstname]=useState('Name');
	const [lastname,setLastname]=useState('');
	const [email,setEmail]=useState('');
	const [bio,setBio]=useState('Hello I am using Clemgram!');
	const [ppic,setPpic]=useState('default');
	*/
	const getAvatar= async()=>{
		if(props.navigation.state.params.pic==='default')
		{
			setPP(prof1);
		}
		else if(props.navigation.state.params.pic==='p1')
		{
			setPP(p1);
		}
		else if(props.navigation.state.params.pic==='p2')
		{
			setPP(p2);
		}
		else if(props.navigation.state.params.pic==='p3')
		{
			setPP(p3);
		}
		else if(props.navigation.state.params.pic==='p4')
		{
			setPP(p4);
		}
		else if(props.navigation.state.params.pic==='p5')
		{
			setPP(p5);
		}
	}
		useEffect(() => {
			getAvatar();
		  }, []);
	if(page===1)
	{
	return( 
		           
		<View style={styles.container}>
			<View style={{flexDirection:"row",alignItems:'left',justifyContent:'left',textAlign:'left'}}>
			<Image         
					style={styles.ichart}
					resizeMode={'center'}
					source={imgSrc2}/>
			<Text style={styles.text2}>Clemgram</Text>
			

			</View>
			<View style={{flexDirection:"row",alignItems:'left',justifyContent:'left',textAlign:'left',marginTop:50}}>
			<Text style={styles.text2}>  </Text>
			<Image         
					style={styles.ipro}
					resizeMode={'center'}
					source={pp}/>
					<View style={{flexDirection:"column",alignItems:'left',justifyContent:'left',textAlign:'left',marginTop:20}}>
						<Text style={styles.text4}>{firstname+"\n\n\t"}<View style={{flexDirection:"row",alignItems:'left',justifyContent:'left',textAlign:'left',marginTop:20}}>
					<Text style={styles.text5}>0 posts        0 followers        0 following</Text>
					
					</View></Text>
					
					<Text style={styles.text6}>{bio}</Text>
					
					</View>
					</View>

			<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:5}}
			 onPress={() => {
				setPage(2);
				//props.navigation.navigate('Main2',{firstname: firstname,lastname: lastname,email: email,pic:ppic,bio:bio});
				}}>
				<Image         
					style={styles.iedit}
					resizeMode={'center'}
					source={editt}/>
			</TouchableOpacity>
			<View  style={{    borderBottomColor: 'white', borderBottomWidth: 1,}}/>
			<View style={{flexDirection:"column",alignItems:'center',justifyContent:'center',textAlign:'center',marginTop:20}}>
			
			<Image         
					style={styles.ipost}
					resizeMode={'center'}
					source={post}/>
				</View>
				<View style={{flexDirection:"row",alignItems:'right',justifyContent:'right',textAlign:'right'}}>
			<TouchableOpacity style={{flexDirection:"row",alignItems:'right',justifyContent:'right',marginRight:15}}
			 onPress={() => {
				//alert(props.navigation.state.params.email);
				update(ref(database, 'users/' + props.navigation.state.params.email), {
					ppic:ppic,
					bio:bio,
					bio1:q1,
					bio2:q2,
					bio3:q3,
					bio4:q4,
					bio5:q5,
				  });
				props.navigation.navigate('Main2',{email: email});
				}}>
				<Image         
					style={styles.iedit}
					resizeMode={'center'}
					source={continu}/>
			</TouchableOpacity>
			</View>

		</View>
	
	)
	}
			else if(page===2)
			{
				return( 
		           
					<View style={styles.container}>
						<View style={{flexDirection:"row",alignItems:'left',justifyContent:'left',textAlign:'left'}}>
						
						<Image         
								style={styles.ichart}
								resizeMode={'center'}
								source={imgSrc2}/>
						<Text style={styles.text12}>Clemgram</Text>
						</View>
						<View style={{flexDirection:"column",alignItems:'center',justifyContent:'center',textAlign:'center'}}>
						
						<Text style={styles.text22}>Edit profile</Text>
						</View>
						<View style={{flexDirection:"column",alignItems:'center',justifyContent:'center',textAlign:'center',marginTop:15}}>
							<Image         
								style={styles.ipro}
								resizeMode={'center'}
								source={pp}/>
								<Text style={styles.text66}  onPress={() => {	
									setPage(3);
									//props.navigation.navigate('Main3',{firstname: firstname,lastname: lastname,email: email,pic:ppic,bio:biog});
								}}>{"Change profile photo\n"}</Text>
			
								<View style={{flexDirection:"column",alignItems:'center',justifyContent:'center',textAlign:'center',marginTop:20}}>
								<Text style={styles.text4}>{"Name\n"}</Text>
								<TextInput
								style={styles.textArea}
								onChangeText={(name) => setFirstname(name)}
								placeholder={firstname}
								placeholderTextColor="black"
								value={firstname}/>
								<Text style={styles.text4}>{"Bio\n"}</Text>
								<Text style={styles.text5}>{"What’s your major?\n"}</Text>
								<TextInput
								style={styles.textArea}
								onChangeText={(bioo) => setQ1(bioo)}
								placeholder={q1}
								placeholderTextColor="black"
								value={q1}/>					
								<Text style={styles.text5}>{"What was your favorite class in High School?\n"}</Text>
								<TextInput
								style={styles.textArea}
								onChangeText={(bioo) => setQ2(bioo)}
								placeholder={q2}
								placeholderTextColor="black"
								value={q2}/>	
								<Text style={styles.text5}>{"Which building do you like the most in Clemson University?\n"}</Text>
								<TextInput
								style={styles.textArea}
								onChangeText={(bioo) => setQ3(bioo)}
								placeholder={q3}
								placeholderTextColor="black"
								value={q3}/>
								<Text style={styles.text5}>{"What’s your favorite restaurant in Clemson?\n"}</Text>
								<TextInput
								style={styles.textArea}
								onChangeText={(bioo) => setQ4(bioo)}
								placeholder={q4}
								placeholderTextColor="black"
								value={q4}/>
								<Text style={styles.text5}>{"What club(s) are you participating in Clemson University?\n"}</Text>
								<TextInput
								style={styles.textArea}
								onChangeText={(bioo) => setQ5(bioo)}
								placeholder={q5}
								placeholderTextColor="black"
								value={q5}/>
								</View>
								</View>
			
						<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:5}}
						 onPress={() => {
							var strr='';
							if(q1!='Prefer not to say!')
							{	strr=strr+' # '+q1;
								setBio(strr);
							}
							if(q2!='Prefer not to say!')
							strr=strr+' # '+q2;
							if(q3!='Prefer not to say!')
							strr=strr+' # '+q3;
							if(q4!='Prefer not to say!')
							strr=strr+' # '+q4;
							if(q5!='Prefer not to say!')
							strr=strr+' # '+q5;
							if(strr!='')
							{
								setBio(strr);
							}
							else{
								strr='Hello I am using Clemgram!'
							}
							//alert("ppic is: "+ppic+"bio is:"+strr);
							setPage(1);
							//props.navigation.navigate('Main',{firstname: firstname,lastname: props.navigation.state.params.lastname,email: props.navigation.state.params.email,pic:ppic,bio:strr});
							}}>
							<Image         
								style={styles.iedit}
								resizeMode={'center'}
								source={saveprof}/>
						</TouchableOpacity>
					</View>
				
				)
			}
			else if(page===3)
			{
				return( 
		           
					<View style={styles.container}>
						<View style={{flexDirection:"row",alignItems:'left',justifyContent:'left',textAlign:'left'}}>
						
						<Image         
								style={styles.ichart}
								resizeMode={'center'}
								source={imgSrc2}/>
						<Text style={styles.text12}>Clemgram</Text>
						</View>
						<View style={{flexDirection:"column",alignItems:'center',justifyContent:'center',textAlign:'center'}}>
						
						<Text style={styles.text22}>Pick one of the profile photos</Text>
						</View>
						<View style={{flexDirection:"column",alignItems:'center',justifyContent:'center',textAlign:'center',marginTop:15}}>
						<View style={{flexDirection:"row",alignItems:'center',justifyContent:'center',textAlign:'center',marginTop:15}}>
						
						<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:5}}
						 onPress={() => {
							setPpic('default');
							setPP(prof1);
							setPage(2);
								}}>
							<Image         
								style={styles.ip}
								resizeMode={'center'}
								source={prof1}/>
						</TouchableOpacity>
						<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:5}}
						 onPress={() => {
							setPpic('p1');
							setPP(p1);
							setPage(2);	}}>
							<Image         
								style={styles.ip}
								resizeMode={'center'}
								source={p1}/>
						</TouchableOpacity>
						<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:5}}
						 onPress={() => {
							setPpic('p2');
							setPP(p2);
							setPage(2);	}}>
							<Image         
								style={styles.ip}
								resizeMode={'center'}
								source={p2}/>
						</TouchableOpacity>
						</View>
						<View style={{flexDirection:"row",alignItems:'center',justifyContent:'center',textAlign:'center',marginTop:15}}>
						<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:5}}
						 onPress={() => {
							setPpic('p3');
							setPP(p3);
							
							setPage(2);	}}>
							<Image         
								style={styles.ip}
								resizeMode={'center'}
								source={p3}/>
						</TouchableOpacity>
						<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:5}}
						 onPress={() => {
							setPpic('p4');
							setPP(p4);
							setPage(2);	}}>
							<Image         
								style={styles.ip}
								resizeMode={'center'}
								source={p4}/>
						</TouchableOpacity>
						<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:5}}
						 onPress={() => {
							setPpic('p5');
							setPP(p5);
							setPage(2);
							}}>
							<Image         
								style={styles.ip}
								resizeMode={'center'}
								source={p5}/>
						</TouchableOpacity>
						</View>
						</View>
					</View>
				
				)
			}

}
//	{false}<Text style={styles.text4}>Your Facebook profile is where other people can post their thoughts, opinions, views, or criticisms about you for everyone to see. </Text>
                               
const styles = StyleSheet.create({
	container: {
		padding: 5,
		flex: 1,
		display: "flex",
		marginTop: 5,
		textAlign: 'center',
		flexDirection: "column",
		justifyContent: "center",
		backgroundColor:"black",
	},
	button: {
		alignItems: "center",
		backgroundColor: "#DDDDDD",
		padding: 10
	  },
	imageContainer: {
		padding: 1,
		marginTop: 1,
		textAlign: 'center',
        flexDirection: "row",
        paddingLeft: Dimensions.get('window').width/11,
		paddingRight: Dimensions.get('window').width/11,
		justifyContent: "center",
	},
	textContainer: {
		textAlign: 'center',
        flexDirection: "column",
		justifyContent: "center",
	},
	ichart: {
		height: Dimensions.get('window').height/15,
		width: Dimensions.get('window').width/13,
	  }, 
	  iedit: {
		height: Dimensions.get('window').height/10,
		width: Dimensions.get('window').width/8,
	  }, 
	  ip: {
		height: Dimensions.get('window').height/3,
		width: Dimensions.get('window').width/3,
	  }, 
	  ipro: {
		height: Dimensions.get('window').height/3,
		width: Dimensions.get('window').width/3,
	  }, 
	  ipost: {
		height: Dimensions.get('window').height/3.5,
		width: Dimensions.get('window').width/3.5,
	  },
	buttonContainer:{
		width: '15%',
		alignSelf: 'center',
		marginTop: 80,
	},
	iweb2: {
		height: Dimensions.get('window').height/2.7,
		width: Dimensions.get('window').width/4,
		marginLeft: 1
	  },
	  text12: {
		//fontWeight: "bold",
		fontSize: 40,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'#FFA500',
		fontFamily: "sans-serif-condensed",
	},
	text: {
		
		fontSize: Dimensions.get('window').width/50,
		color:'#3a9BDC',
		marginRight: 5,
		marginLeft: 5,
	},
    text2: {
		//fontWeight: "bold",
		fontSize: 40,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'#FFA500',
		fontFamily: "sans-serif-condensed",
	},
	text22: {
		fontWeight: "bold",
		fontSize: 40,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
    text4: {
		fontSize: 30,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'left',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	text5: {
		fontSize: 23,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	text66: {fontSize: 22, 
	fontWeight: "bold",       
	marginBottom: 15,
	//fontStyle: 'italic',
	//marginTop:20,        
	textAlign: 'center',
	color:'blue',
	fontFamily: "sans-serif-condensed",
	},
	text6: {
		fontSize: 22,        
        marginBottom: 15,
		//fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'left',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	image: {
		flex: 1,
		justifyContent: "center"
	  },
	buttonStyle: {
	alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 52,
	paddingHorizontal: 32,
	paddingTop: 20,
	borderRadius: 1,
	borderWidth:10,
	elevation: 13,
	backgroundColor:"#341ada"
	},
	listContainer: {
		paddingTop: 20
	},
	listItem: {
		fontSize: 20
	},
	text3: {
		marginTop: 20,        
        marginBottom: 20,        
        textAlign: 'center',
		fontSize: Dimensions.get('window').width/70,
		color:'#03C04A',
		marginRight: Dimensions.get('window').width/5,
		marginLeft: Dimensions.get('window').width/5,
		
	},
	  textAreaContainer: {
		
		paddingTop: 30,
		paddingRight:Dimensions.get('window').width/2.5,
		paddingLeft: Dimensions.get('window').width/2.5,
		paddingBottom: 30,
		textAlign: 'center',

	  },
	  textArea: {
		height: 50,
		width:250,
		fontSize: 16,
		borderColor: 'white',
		backgroundColor:'white',
		color:'black',
		borderWidth: 1,
		marginBottom: 20,
		justifyContent: "center"
	  },
	  checkboxContainer: {
		flexDirection: "row",
		
	  },
	  checkbox: {
		alignSelf: "center",
	  },
})
export default Info